import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Assets from "imports/assets.import";
import ChipButton from "common_components/ui/chip_button/chip_button.ui";
import { STRINGS } from "constants/strings.constant";
import { PropertiesTypes, TransformType } from "utils/interface.utils";
import { AppDispatch, RootState } from "store/store";
import { setSelectedTransformControl } from "store/reducers/editorSlice";
import "./transform_toolbar.component.scss";

// The Position / Rotate / Scale pill at the top of the canvas: picks how the selected object is
// transformed on the canvas. It shows only while one of the target's objects is the selection.
const TransformToolbar = () => {
    const dispatch = useDispatch<AppDispatch>();
    const { currentSelectedPropertyType, targetImageDataList, selectedTargetIndex, selectedTransformControl } = useSelector((state: RootState) => state.editor);
    const strings = STRINGS.editor.transformToolbar;

    const isObjectSelected = currentSelectedPropertyType !== null && currentSelectedPropertyType !== PropertiesTypes.TARGET;
    const objectCount = targetImageDataList[selectedTargetIndex ?? 0]?.objects.length ?? 0;
    if (!isObjectSelected || objectCount === 0) return null;

    const controls = [
        { name: TransformType.POSITION, label: strings.position, icon: Assets.transform_position },
        { name: TransformType.ROTATION, label: strings.rotation, icon: Assets.transform_rotation },
        { name: TransformType.SCALE, label: strings.scale, icon: Assets.transform_scale },
    ];

    return (
        <div className="transform_toolbar" role="toolbar" aria-label={strings.label}>
            {controls.map((control) => {
                const isActive = selectedTransformControl === control.name;
                return (
                    <ChipButton
                        key={control.name}
                        className="transform_toolbar_item"
                        text={control.label}
                        icon={control.icon}
                        isActive={isActive}
                        onClick={() => {
                            dispatch(setSelectedTransformControl(isActive ? null : control.name));
                        }}
                    />
                );
            })}
        </div>
    );
};

export default TransformToolbar;
